import { useNavigate } from 'react-router-dom'
import { ScanLine, ChevronRight } from 'lucide-react'
import { useHouseholdId } from '../../hooks/useHouseholdId'
import { useStartSpontaneousTrip } from '../../hooks/useStartSpontaneousTrip'
import { showToast } from '../../lib/toastStore'

// Combined Home action — both ways to start a "just got back" trip live in
// one card. Tapping the card body kicks off scan flow (creates a spontaneous
// shopping_lists row, routes to Unpack, scanner auto-opens). The secondary
// "Add manually" link below uses the same trip but appends skipScan=1 so
// Unpack lands on the empty form instead of the camera.
export function ScanReceiptButton() {
  const navigate    = useNavigate()
  const householdId = useHouseholdId()
  const { start, loading } = useStartSpontaneousTrip()

  async function startTrip(autoScan: boolean) {
    if (!householdId || loading) return
    const id = await start(householdId)
    if (!id) {
      showToast('Could not start a new trip — try again')
      return
    }
    const skip = autoScan ? '' : '&skipScan=1'
    navigate(`/unpack?mode=spontaneous&listId=${id}${skip}`)
  }

  return (
    <div className="bg-paper border border-border-sand rounded-3xl p-5 mb-4">
      <button
        type="button"
        onClick={() => startTrip(true)}
        disabled={loading || !householdId}
        className="w-full flex items-center gap-3 text-left disabled:opacity-60"
      >
        <div className="bg-cream rounded-2xl h-11 w-11 flex items-center justify-center flex-shrink-0">
          <ScanLine className="h-5 w-5 text-ink" strokeWidth={1.75} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] uppercase tracking-[0.18em] text-ink-muted font-medium">
            Just got back?
          </p>
          <p className="font-serif text-[16px] text-ink leading-[1.2] mt-0.5">
            Scan a <em className="italic text-forest">receipt</em>
          </p>
        </div>
        <ChevronRight className="h-5 w-5 text-ink-muted flex-shrink-0" strokeWidth={2} />
      </button>

      <div className="mt-4 pt-4 border-t border-border-hairline">
        <button
          type="button"
          onClick={() => startTrip(false)}
          disabled={loading || !householdId}
          className="font-serif text-[13px] italic text-ink-muted hover:text-ink underline-offset-4 hover:underline disabled:opacity-60"
        >
          Or add items manually →
        </button>
      </div>
    </div>
  )
}
